<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :value.sync="queryParams.version"
                selectType="select"
                requestApi="/scp/scpMpsPlans/listMpsPlanVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <global-select
                :max-tag-count="1"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.listCategoryCodeList"
                selectType="selectMultiple"
                :selectData="productBroadCategoryOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="内外部">
              <global-select
                @change="queryParams.supplierIdList=undefined"
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.listPlanGroup"
                selectType="select"
                :selectData="listSideOpinions"
                :selectItem="{ value: 'attribute1', label: 'attribute1' }"
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">

            <a-col :md="6" :sm="24">
              <a-form-item label="计划单类型">
                <global-select
                  :max-tag-count="1"
                  :max-tag-text-length="4"
                  show-search
                  :value.sync="queryParams.typeList"
                  selectType="select"
                  :selectData="listSupplyTypeOpinions"
                  :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="供应商">
                <global-select
                  :max-tag-count="1"
                  :max-tag-text-length="4"
                  show-search
                  :setParams="{scpSupplierCategory:queryParams.listPlanGroup}"
                  :value.sync="queryParams.supplierIdList"
                  :dropdown-match-select-width="false"
                  selectType="selectMultipleSearch"
                  requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
                  searchParam="supplierName"
                  :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="物料编码">
                <global-select
                  :assembleLabel="true"
                  :value.sync="queryParams.itemIdList"
                  selectType="selectAssembleMultipleSearch"
                  :dropdown-match-select-width="false"
                  requestApi="/scp/scpMpsPlans/listItemCodeCp"
                  :selectItem="{ value: 'realValue', label: 'selectedValue', thirdLabel: 'bringOutDataOne' }"
                  searchParam="itemCode" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <span slot="version" slot-scope="{ record }">
            <a @click="handleGoDetail(record)" class="ml10">{{ record.version }}</a>
          </span>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="newDuckDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a class="ml10" @click="handleDel(record)">删除</a>
          </span>
        </ls-api-table>
      </div>
    </template>

  </ls-table-layout>
</template>

          <script>
      import { generateLsTableResData } from '@/utils/util.js'
       import { ApiUpdateSopMonthPlan, ApiSendSopMonthPlan } from '@/api/scp/month-plan/month-plan.js'
       import moment from 'moment';
       import { ApiStopScpMpsPlans } from '@/api/mps/basic-data/mps-option.js'
       import { apiDeleteSupplierDetail } from '@/api/mps/basic-data/mps-supply-details.js'
       import { apiGrantResult } from '@/api/mps/basic-data/mps-plan-execution.js'

      export default {
        // eslint-disable-next-line
        name: 'result', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
        components: {
        },
        computed: {
        // 其他计算属性
        // ...
        formattedParams () {
          return {
            monthStart: moment(this.currentPeriod).format("YYYYMM")
            // monthEnd: moment(this.baseInfo.forecastPeriodTo).format("YYYYMM")
          };
        }
      },
        data () {
          return {
            url: '/scp/scpMpsPlans/importSupplierDetail',
            listSideOpinions: [],
            listSupplyTypeOpinions: [],
            productBroadCategoryOpinions: [],
            moment: moment, // 在 data 中创建 moment 实例
            currentPeriod: '',
            isEdit: false,
            currentId: "",
            advanced: true,
            lookUpCode: '',
            // 表格多选
            selectedRowKeys: [],
            selectedRows: [],
            // 表格配置
            tableProps: {
              requestApi: generateLsTableResData(apiGrantResult, true),
              pageCurrent: true
            },
            // 查询参数
            queryParams: {
                version: undefined,
                listCategoryCodeList: undefined,
                typeList: undefined,
                supplierIdList: undefined,
                itemIdList: undefined,
                listPlanGroup: undefined
            },
            baseUomFlagOptions: [
              {
                dictLabel: '是',
                dictValue: 'Y'
              },
              {
                dictLabel: '否',
                dictValue: 'N'
              }
            ],
            // 表格字段
            columns: [
              {
                title: '物料编码',
                dataIndex: 'itemCode',
                ellipsis: true,
                width: 150,
                align: 'center'
              },
              {
                title: '工艺大类',
                dataIndex: 'category',
                ellipsis: true,
                align: 'center',
                width: 180
              },
              {
                title: '物料名称',
                width: 120,
                dataIndex: 'itemName',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '规格描述',
                width: 220,
                ellipsis: true,
                dataIndex: 'specification',
                align: 'left'
              },
              {
                title: '供应商',
                width: 200,
                dataIndex: 'supplierName',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '内外部',
                width: 100,
                dataIndex: 'planGroup',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '订单类型',
                width: 140,
                dataIndex: 'type',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '单据编号',
                width: 220,
                dataIndex: 'orderNumber',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '完成日期',
                width: 180,
                dataIndex: 'finishDate',
                scopedSlots: { customRender: 'newDuckDate' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '数量',
                width: 120,
                dataIndex: 'quantity',
                ellipsis: true,
                align: 'center'
              }
              // {
              //   title: '操作',
              //   width: 150,
              //   fixed: 'right',
              //   align: 'center',
              //   dataIndex: 'operation',
              //   scopedSlots: { customRender: 'operation' }
              // }
            ]
          }
        },
        created () {
          this.queryParams.version = this.$route.query.version
         // this.getLastSalesForecast()
       //  this.getLookUpCode('SOP_PROCESS_STATU')
       this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryOpinions')
       this.getLookupList('SCP_MRP_SUPPLY_TYPE', 'listSupplyTypeOpinions')
       this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'listSideOpinions')
        },
        mounted () {
          if (this.queryParams.version) {
            this.onSearch()
          }
        },
        methods: {
          toggleAdvanced () {
            this.advanced = !this.advanced
          },
          handImport () {
            if (this.queryParams.version) {
              this.$refs.importData.show(this.queryParams.version)
            } else {
              this.$message.error('版本不能为空')
            }
          },
              /** 下载模板操作 */
          importTemplate () {
            this.download('scp/scpMpsPlans/exportSupplierDetailTemplate', {
              ...this.queryParams
            }, `供应明细模板.xlsx`)
          },
        // 导入导出excel
          /** 导出按钮操作 */
          handleExport () {
            this.download('scp/scpMpsPlans/exportGrantResult', {
              ...this.queryParams
            }, `导出发放结果_${new Date().getTime()}.xlsx`)
          },
        getLookupList (type, arr) {
            const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
            }
            this.getLookupListData(lookupQueryParams).then(response => {
            this[arr] = response.rows
            if (type === 'SCP_MRP_SUPPLY_TYPE') {
                const filteredArray = response.rows.filter(function (obj) {
                    return obj.attribute2 === "Y";
                    });
                    this[arr] = filteredArray
            }
            if (type === 'MDM_ORG_SUPPLIER_CLASS') {
                const filteredArray = response.rows.filter(function (obj) {
                    return obj.attribute2 === "Y";
                    });
                    this[arr] = filteredArray
            }
            })
        },
              // 新增/修改框事件
        handleOk () {
          this.onSearch()
        },
          handleStopCalculationAlert () {
                  /** 检查只能选择一个 */
              if (this.selectedRows.length > 1) {
                    this.$message.error('停止计算选择项不能大于1')
                    return
                  }
                  if (this.selectedRows.length === 0) {
                    this.$message.error('请勾选其中一项')
                    return
                  }
                  const self = this
                  this.$confirm({
                    title: '提示',
                    content: '你确定停止该记录吗？',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk () {
                      self.handleStopCalculation()
                    },
                    onCancel () {
                    }
                  });
          },
          handleStopCalculation () {
            ApiStopScpMpsPlans(this.selectedRowKeys[0]).then(response => {
              if (response.code === 200) {
                this.$message.success('停止成功')
              } else {
                this.$message.error(response.msg)
              }
            })
          },
            getLookUpCode (code) {
                const lookupQueryParams = {
                    lookupType: code,
                    current: 1,
                    pageSize: 100
                }
                this.getLookupListData(lookupQueryParams).then().then(response => {
                // this.lookUpCode[code] = response.rows
                this.$set(this.lookUpCode, code, response.rows)
                })
            },
          resetQuery () {
            this.queryParams = {
                version: undefined,
                listCategoryCodeList: undefined,
                typeList: undefined,
                supplierIdList: undefined,
                itemIdList: undefined,
                listPlanGroup: undefined
            }
            this.onSearch()
          },
          handleGoCapacityLoad () {
            /** 检查只能选择一个 */
            if (this.selectedRows.length > 1) {
              this.$message.error('产能负荷的选择项不能大于1')
              return
            }
            if (this.selectedRows.length === 0) {
              this.$message.error('请勾选其中一项')
              return
            }
            this.$router.push({ path: `/monthly-plan/capacityLoadPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
          },
          handleGoDemand () {
                    /** 检查只能选择一个 */
                    if (this.selectedRows.length > 1) {
              this.$message.error('生产需求的选择项不能大于1')
              return
            }
            if (this.selectedRows.length === 0) {
              this.$message.error('请勾选其中一项')
              return
            }
            this.$router.push({ path: `/monthly-plan/productionDemandPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
          },
          handleDel (record) {
            const self = this
            this.$confirm({
              title: '提示',
              content: '你确定删除该记录吗？',
              okText: '确定',
              okType: 'danger',
              cancelText: '取消',
              onOk () {
                self.deleteShipmentForecast(record)
              },
              onCancel () {
              }
            });
          },
          handleGoStatus (record) {
            this.$router.push({ path: `/shipmentForecastManagement/runningStatus/${record.id}` })
          },
          deleteShipmentForecast (record) {
            apiDeleteSupplierDetail(record.id).then((response) => {
              if (response.code === 200) {
                this.$message.success('删除成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
          },
          sendShipmentForecast (record) {
            ApiSendSopMonthPlan({ id: record.id }).then((response) => {
              if (response.code === 200) {
                this.$message.success('发布成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
          },
          handleGoDetail (record) {
            this.$router.push({ path: `/mps-work-desk/detail/${record.id}` })
          },
          handleEdit (record) {
            if (this.currentId && record.id !== this.currentId && this.isEdit) {
                  this.$message.warning('请保存上次编辑的数据')
                  return;
                }
                this.isEdit = true;
                this.currentId = record.id;
          },
          handleAdd () {
            this.$router.push({ path: `/monthly-plan/editPage/` })
          },
          /** 行选中 */
          selectedRowChange (selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
          },
          // 表单搜索
          onSearch () {
            if (!this.queryParams.version) {
              this.$message.error('请输入版本')
              return
           }
            this.isEdit = false
            this.$refs.dataTable.searchParams = this.queryParams
            this.$refs.dataTable.getData()
          },
          // 编辑-保存
          handleSave (record) {
            // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
            //   this.$message.warning('折换不能为空且需大于0')
            //   return
            // }
             ApiUpdateSopMonthPlan(record).then(response => {
                if (response.code === 200) {
                  this.$message.success('保存成功')
                  this.onSearch()
                } else {
                  this.$message.error(response.msg)
                }
              })
          },
          // 取消
          handleCancel (record) {
            this.isEdit = false
            this.onSearch()
          },
          statusOnChange (record) {
            record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
          }
        }
      }
      </script>

     <style scoped lang="less">
      .ml10 {
        margin-left: 10px;
      }
      </style>
